import { api } from "./interceptors";

/**
 * User Service - Handles all user-related API calls
 */
const userService = {
  /**
   * Get current user details
   * @returns {Promise} - Returns current user data
   */
  getCurrentUser: async () => {
    try {
      const response = await api.get("/users/me/");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default userService;
